import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { PaymentModel, PaymentCheckModel, SubscriberModel } from '../models/superbit-api-models';
import { SubscribersModel } from '../models/SubscribersModel';
import '../assets/css/_simple-popup.css'
import '../assets/css/_new-lead-popup.css'
//import './_VehicleDetails.css'
import '../vehicles/_VehicleDetails.css'
import { GovData1, GovData2, ManulApiModel } from '../models/ManulApiModel'
import { GetBanks } from '../models/CacheModel'
import exampleIcon from '../assets/images/license2.webp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { SimulatorModel } from '../models/SimulatorModel';

import { DynamicSelect } from '../components/_DynamicSelect';
import { IDNameDescriptionItemSelect } from '../components/_IDNameDescriptionItemSelect';
import { IDNameDescriptionItem, IDNameDescriptionDictionary, AutocompleteData } from '../models/Site'
import { Autocomplete } from '../components/_Autocomplete';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import VehicleDetails from "../vehicles/_VehicleDetails";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import moment from 'moment';
type Props = {
    Payment: PaymentModel | undefined,
    EditPayment: Function
};



const PaymentItem = (props: Props) => {
    const [Payments, setPayments] = useState<PaymentModel[] | undefined>([]);
    const init = async () => {

    }

    useEffect(() => {
        
    }, [])

    const editPaymentClicked = (id: string | undefined) => {
        if (id) {
            props.EditPayment(id);
        }
    }


    const paymentMethodTypes: string[] = [
        "כרטיס אשראי",
        "המחאה",
        "העברה בנקאית",
        "אחר"
    ];

    const paymentStauses: string[] = [
        "לא שולם",
        "שולם",
        "בוטל",
        "הוקפא",
        "שגיאה",
        ""
    ];

    const isAdmin=() =>{
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            return loggedUser.role == 0 
        }
        return false;
    }

    return (
        <>
            <div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="value1">
                                {props.Payment ? props.Payment.title : ""}
                            </div>

                        </div>
                    </div>
                    <div className={`parameter-item`}>
                        <div className="field">
                            <div className="value1">
                                {props.Payment ? props.Payment.amount : ""}
                            </div>

                        </div>
                    </div>
                    <div className={`parameter-item `}>
                        <div className="field">
                            <div className="value1">
                                {props.Payment && props.Payment.paymentMethodType!=undefined ? paymentMethodTypes[props.Payment.paymentMethodType] : ""}
                            </div>

                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="value1">
                                {props.Payment ? moment(props.Payment.createdDate).format('DD-MM-YYYY') : ""}
                            </div>

                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="value1">
                                {props.Payment && props.Payment.paymentStatus != undefined ? paymentStauses[props.Payment.paymentStatus] : ""}

                            </div>

                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="value1">
                                {props.Payment && props.Payment.id && ((props.Payment.paymentStatus == 0)) ?
                                    <div onClick={(e: any) => editPaymentClicked(props.Payment && props.Payment.id ? props.Payment.id : "")}><FontAwesomeIcon icon={faPenToSquare} /></div>
                                    : ""}

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};


export default PaymentItem;
